"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useBreakPoint = require("../../../../common/useBreakPoint");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Slide = _ref => {
  let {
    title,
    top,
    lead,
    tag,
    src,
    srcTablet,
    srcMobile
  } = _ref;
  const {
    isDesktop,
    isTablet,
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "slide"
  }, isDesktop && /*#__PURE__*/_react.default.createElement("img", {
    className: "slide-img",
    src: src
  }), isTablet && /*#__PURE__*/_react.default.createElement("img", {
    className: "slide-img",
    src: srcTablet || src
  }), isMobile && /*#__PURE__*/_react.default.createElement("img", {
    className: "slide-img",
    src: srcMobile || src
  }), tag && /*#__PURE__*/_react.default.createElement("div", {
    className: `tag sia-text-06`
  }, /*#__PURE__*/_react.default.createElement("span", null, tag)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-02-top sia-padding-02-left sia-padding-04-right"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-01",
    dangerouslySetInnerHTML: {
      __html: top
    }
  }), /*#__PURE__*/_react.default.createElement("h3", {
    className: "sia-text-14",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "lead sia-text-10",
    dangerouslySetInnerHTML: {
      __html: lead
    }
  })));
};
Slide.propTypes = {
  title: _propTypes.default.string.isRequired,
  top: _propTypes.default.string.isRequired,
  lead: _propTypes.default.string.isRequired,
  tag: _propTypes.default.string,
  src: _propTypes.default.string.isRequired,
  srcTablet: _propTypes.default.string,
  srcMobile: _propTypes.default.string
};
var _default = exports.default = Slide;